/* eslint-disable react/react-in-jsx-scope */
import { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Input } from "antd";
import apiClient from "../../helpers/apiClient";

function ForgotPass() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [step, setStep] = useState(1);
    const [email, setEmail] = useState("");
    const [otp, setOtp] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [otpVerified, setOtpVerified] = useState(false);
    const emailRef = useRef();

    const handleSendOtp = async (e) => {
        e.preventDefault();
        setError("");
        setSuccess("");
        setOtpVerified(false);
        setLoading(true);

        const emailValue = emailRef.current.value;
        setEmail(emailValue);

        try {
            const response = await apiClient.post("api/auth/forget-password/send-otp", {
                email: emailValue,
            });

            if (response.data.success) {
                setSuccess(response.data.message);
                setStep(2);
            } else {
                setError(response.data.message || "Failed to send OTP. Please try again.");
            }
        } catch (_error) {
            setError(_error.response?.data?.message || "An error occurred. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const handleVerifyOtp = async (e) => {
        e.preventDefault();
        setError("");
        setSuccess("");
        setOtpVerified(false);
        setLoading(true);

        try {
            const response = await apiClient.post("api/auth/forget-password/verify-otp", {
                email,
                otp,
            });

            if (response.data.success) {
                setOtpVerified(true);
                setSuccess("OTP verified successfully");
                setStep(3);
            } else {
                setError(response.data.message || "Failed to verify OTP. Please try again.");
            }
        } catch (_error) {
            setError(_error.response?.data?.message || "An error occurred. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const handleResetPassword = async (e) => {
        e.preventDefault();
        setError("");
        setSuccess("");

        if (newPassword !== confirmPassword) {
            setError("Passwords do not match");
            return;
        }

        if (newPassword.length < 8) {
            setError("Password must be at least 8 characters long");
            return;
        }

        setLoading(true);

        try {
            const response = await apiClient.post("api/auth/reset-password", {
                email,
                newPassword,
                otp,
            });

            if (response.data.success) {
                setOtpVerified(false);
                setSuccess("Password reset successful. You can now login with your new password.");
                // Optional: redirect to login page after some time
                setTimeout(() => {
                    window.location.href = "/login";
                }, 3000);
            } else {
                setError(response.data.message || "Failed to reset password. Please try again.");
            }
        } catch (_error) {
            setError(_error.response?.data?.message || "An error occurred. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className="h-[95vh] w-full flex justify-center items-center">
                <div className="w-[40rem] py-10 bg-[#f2f2fa] rounded-lg flex flex-col justify-center items-center gap-y-10">
                    <h2 className="font-bold text-[#5d5dff] text-4xl flex flex-col items-center justify-center">
                        <span>Forgot</span>
                        <span>your password?</span>
                    </h2>
                    {error && <div className="text-red-500">{error}</div>}
                    {success && !otpVerified && <div className="text-green-600">{success}</div>}
                    {otpVerified && step === 2 && <div className="text-green-600">OTP verified successfully</div>}

                    {step === 1 && (
                        <form onSubmit={handleSendOtp} className="flex flex-col gap-y-8 w-[75%]">
                            <div className="fontRegular">
                                <div className="flex flex-col justify-between gap-2">
                                    <label htmlFor="email">E-mail:</label>
                                    <input
                                        type="email"
                                        ref={emailRef}
                                        name="email"
                                        required
                                        placeholder={"username@carapp"}
                                        className="rounded-lg p-2 outline-none w-full"
                                    />
                                </div>
                            </div>
                            {/* Submit button */}
                            <div className="flex flex-col justify-center items-center">
                                <div className="fontSemi w-48">
                                    {loading ? (
                                        <Button
                                            className="bg-[#5d5dff] text-white hover:!bg-[#5d6dff] hover:!text-white"
                                            loading={true}
                                            block
                                            shape="round"
                                            >
                                            Sending OTP
                                        </Button>
                                    ) : (
                                        <Button
                                            htmlType="submit"
                                            variant="solid"
                                            className="bg-[#5d5dff] text-white hover:!bg-[#5d6dff] hover:!text-white"
                                            block
                                            shape="round"
                                            >
                                            Send OTP
                                        </Button>
                                    )}
                                </div>
                                <div className="mt-6">
                                    <Link to="/login" style={{ textDecoration: "none" }} className="font-normal">
                                        <span
                                            style={{
                                                color: "#5d5dff",
                                                cursor: "pointer",
                                            }}>
                                            Login
                                        </span>
                                    </Link>
                                </div>
                            </div>
                        </form>
                    )}

                    {step === 2 && (
                        <form onSubmit={handleVerifyOtp} className="flex flex-col gap-y-8 w-[75%]">
                            <div className="fontRegular">
                                <div className="flex flex-col justify-between gap-2">
                                    <label htmlFor="otp">Enter OTP:</label>
                                    {/* <input
                    type="text"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    name="otp"
                    required
                    placeholder="Enter OTP sent to your email"
                    className="rounded-lg p-2 outline-none w-full"
                  /> */}
                                    <Input.OTP length={6} onChange={(text) => setOtp(text)} />
                                </div>
                            </div>

                            <div className="flex flex-col justify-center items-center">
                                <div className="fontSemi w-56">
                                    {loading ? (
                                        <Button
                                            className="bg-[#5d5dff] text-white hover:!bg-[#5d6dff] hover:!text-white"
                                            loading={true}
                                            block
                                            shape="round"
                                            >
                                            Verifying OTP
                                        </Button>
                                    ) : (
                                        <Button
                                            htmlType="submit"
                                            variant="solid"
                                            className="bg-[#5d5dff] text-white hover:!bg-[#5d6dff] hover:!text-white"
                                            block
                                            shape="round"
                                            >
                                            Verify OTP
                                        </Button>
                                    )}
                                </div>
                                <div className="mt-6">
                                    <Link to="/login" style={{ textDecoration: "none" }} className="font-normal">
                                        <span
                                            style={{
                                                color: "#5d5dff",
                                                cursor: "pointer",
                                            }}>
                                            Login
                                        </span>
                                    </Link>
                                </div>
                            </div>
                        </form>
                    )}

                    {step === 3 && (
                        <form onSubmit={handleResetPassword} className="flex flex-col gap-y-8 w-[75%]">
                            <div className="fontRegular space-y-6">
                                <div className="flex flex-col justify-between gap-2">
                                    <label htmlFor="newPassword" className="w-60">
                                        New Password:
                                    </label>
                                    <input
                                        type="password"
                                        value={newPassword}
                                        onChange={(e) => setNewPassword(e.target.value)}
                                        name="newPassword"
                                        required
                                        placeholder="Enter new password"
                                        className="rounded-lg p-2 outline-none w-full"
                                    />
                                </div>

                                <div className="flex flex-col justify-between gap-2">
                                    <label htmlFor="confirmPassword" className="w-60">
                                        Confirm Password:
                                    </label>
                                    <input
                                        type="password"
                                        value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                        name="confirmPassword"
                                        required
                                        placeholder="Confirm new password"
                                        className="rounded-lg p-2 outline-none w-full"
                                    />
                                </div>
                            </div>

                            <div className="flex flex-col justify-center items-center">
                                <div className="fontSemi w-64">
                                    {loading ? (
                                        <Button
                                            className="bg-[#5d5dff] text-white hover:!bg-[#5d6dff] hover:!text-white"
                                            loading={true}
                                            block
                                            shape="round"
                                            >
                                            Resetting Password
                                        </Button>
                                    ) : (
                                        <Button
                                            htmlType="submit"
                                            variant="solid"
                                            className="bg-[#5d5dff] text-white hover:!bg-[#5d6dff] hover:!text-white"
                                            block
                                            shape="round"
                                            >
                                            Reset Password
                                        </Button>
                                    )}
                                </div>
                                <div className="mt-6">
                                    <Link to="/login" style={{ textDecoration: "none" }} className="font-normal">
                                        <span
                                            style={{
                                                color: "#5d5dff",
                                                cursor: "pointer",
                                            }}>
                                            Login
                                        </span>
                                    </Link>
                                </div>
                            </div>
                        </form>
                    )}
                </div>
            </div>
            <div className="text-[#acacb9] text-center">&copy; Car-Application | {new Date().getFullYear()}</div>
        </>
    );
}

export default ForgotPass;
